import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    viewShared: {
        id: "planCard.viewShared",
    },
    viewListed: {
        id: "planCard.viewListed",
    },
});

export default messages;
